import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material';
import { brandConfig } from '@config/brand.config';
import { createBrowserHistory } from 'history';
import Router from './Router';
import { StoreProvider } from '@ui/providers/Store.provider';
import RouterProvider from '@ui/providers/Router.provider';
import { rootStore } from '@store/Root.store';

const history = createBrowserHistory();
const theme = brandConfig.palette
    ? createTheme({
          palette: {
              primary: { main: brandConfig.palette.primary },
              secondary: { main: brandConfig.palette.secondary },
          },
      })
    : undefined;

const App = () => {
    const content = (
        <StoreProvider value={rootStore}>
            <RouterProvider basename="/" history={history}>
                <Router />
            </RouterProvider>
        </StoreProvider>
    );
    return theme ? (
        <ThemeProvider theme={theme}>{content}</ThemeProvider>
    ) : (
        content
    );
};

export default App;
